export default "__VITE_ASSET__DPC5Q$Ee__"